import * as React from 'react';

import PayrollPage from './PayrollPage';

// Work Evidence now lives as a tab of the Payroll page. The legacy "Work Evidence" route (deep
// links, bookmarks, in-app navigate('Work Evidence')) opens Payroll on that tab.
export default function WorkEvidencePage(): React.JSX.Element {
    return <PayrollPage initialTab="workEvidence"/>;
}
